import React, { Component } from 'react'
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Label,
  Input,
} from "reactstrap"
import TextEditor2 from '../TextEditor/TextEditor2'
import AnswerChoiceEditor from './AnswerChoiceEditor'
import NodeTagger from './CreateManageContent/NodeTagger'
import ItemInfo from './CreateManageContent/ItemInfo'
import SelectItemType from './CreateManageContent/SelectItemType'
import itemTypeDisplay from '../../helpers/itemTypeDisplay'
import {
  ItemRows,
  ItemsTable,
  PassageCard,
  ContentCard,
  NewContentCard,
  AnswerCards,
  ImageManagerModal,
  TextInput,
} from './ManageContentComponents'
import {
  Filter
} from '../Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents'
import { db } from '../../config/firebaseconfig';
import postFeedback from '../../helpers/content/manageContent/postFeedback'
import queryString from 'query-string'

class ManageContent extends Component {

  state = {
    filter: '',
    activeEditor: '',
    loading: false,
    activeItem: null,
  }

  openEditor = (fieldName, editorData) => {
    this.props.handleChangeActiveEditor(null, editorData)
    this.setState({activeEditor: fieldName})
  }

  closeEditor = () => this.setState({activeEditor: ''})

  filterChg = ({target}) => this.setState({filter: target.value})

  handleClickItem = (item) => {
    this.setState({activeEditor: ''})
    this.props.handleClickItem(item)
  }

  subscribeToItem = (id) => {
    let { activeItemId } = this.props
    activeItemId = activeItemId || id
    if (activeItemId) {
      this.setState({loading: true})
      this.unsubscribe = db.collection('contentItems').doc(activeItemId).onSnapshot((snapshot) => {
        this.setState({activeItem: snapshot.data(), loading: false})
      },
      (err) => {
        this.setState({error: 'Error loading item.', loading: false})
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { activeItemId } = this.props
    if (prevProps.activeItemId !== activeItemId) {
      const { unsubscribe, subscribeToItem } = this
      if (unsubscribe) unsubscribe()
      subscribeToItem()
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
  }

  copyFeedback = feedback => {
    const { activeItem } = this.state
    postFeedback(activeItem, feedback)
      .then()
      .catch()
  }

  render() {
    const { 
      contentType,
      handleClickSave,
      items,
      activeItemId, 
      activeItem,
      quillText,
      handleQuillChange,
      search,
      history,
      setContentType,
      handleNewItemClick,
      handleItemDelete,
      isFetching,
      toggleShuffle,
      setStartingLetter,
      startingLetter,
      handleInfoChange, 
      itemName, 
      itemCode,
      handleChangeItemType,
      nodes,
      addNodeTag,
      deleteNodeTag,
    } = this.props
    let display = {
      passage: false,
      question: false,
      answers: false,
    }
    if (activeItemId) {
      display = itemTypeDisplay[activeItem.itemType]
    }

    const itemsFetching = <div><i className="fa fa-circle-o-notch fa-lg fa-spin mr-1 ml-1"></i></div>

    let colorScheme
    const colors = {
      Course: 'warning',
      Lesson: 'success',
      Set: 'info',
      Item: 'primary',
    }
    contentType
    ? colorScheme = colors[contentType]
    : colorScheme = 'primary' 

    let saveButton
    if (activeItemId) {
      if (activeItem.noChanges) {
        saveButton = <Button color='primary mt-1 ml-1' disabled>Saved</Button>
      } else if (activeItem.isSaving) {
        saveButton = <Button color='primary mt-1 ml-1'><i className="fa fa-circle-o-notch fa-lg fa-spin mr-1 ml-1"></i></Button>
      } else {
        saveButton = <Button color='primary mt-1 ml-1' onClick={(e) => handleClickSave(e)}>Save</Button>
      }
    } else {
      saveButton = <div></div>
    }

    const { filter, activeEditor, loading } = this.state
    const { passage, passageId } = activeItem
    const { openEditor, closeEditor, handleClickItem, copyFeedback } = this

    const query = queryString.parse(search)
    const imageManagerIsOpen = query.im

    return (
      <div className='animated fadeIn'>
      <ImageManagerModal 
        search={search}
        history={history}
        query={query}
      />
      <Row>
        <Col xs="12" lg="4">
            <Card>
              <CardHeader>
                <Button
                  className='mt-1'
                  color={contentType === 'Item' ? 'primary' : 'secondary'}
                  onClick={() => setContentType('Item') }                      
                >
                  Items
                </Button>
                <Button 
                  className='mt-1'
                  color={contentType === 'Set' ? 'info' : 'secondary'}
                  onClick={() => setContentType('Set')}
                >
                  Sets
                </Button>
                <Button 
                  className='mt-1'
                  color={contentType === 'Lesson' ? 'success' : 'secondary'}
                  onClick={() => setContentType('Lesson')}                    
                >
                  Lessons
                </Button>
                <Button 
                  className='mt-1'
                  color={contentType === 'Course' ? 'warning' : 'secondary'}
                  onClick={() => setContentType('Course')}  
                >
                  Courses
                </Button>
                <Button 
                  className='mt-1 ml-1'
                  color='success'
                  onClick={() => handleNewItemClick()}
                >+ New Item
                </Button>
                <Button
                  className='mt-1'
                  color='danger'
                  onClick={() => handleItemDelete(activeItemId)}
                  disabled={activeItemId ? false : true}
                >Delete
                </Button>{' '}
                {saveButton}
                <Filter 
                  onChg={this.filterChg}
                  filter={filter}
                  placeholder={'Search items...'}
                />
              </CardHeader>
              <CardBody className="card-body" >
                {isFetching 
                  ? itemsFetching 
                  : <ItemsTable 
                      items={items}
                      activeItemId={activeItemId}
                      handleClickItem={handleClickItem}
                      filter={filter && filter.toLowerCase()}  
                    />
                }
              </CardBody>
            </Card>
          </Col>
          <Col xs='12' lg='8'>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    {activeItemId ? activeItemId : 'Select an Item'}
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs='12' className='mt-2'>
                        <Label className={"switch switch-3d mr-2 switch-" + colorScheme}>
                          <Input 
                            type="checkbox" 
                            className="switch-input" 
                            checked={activeItem.shuffle}
                            value={activeItem.shuffle ? 'on' : 'off'}
                            onChange={() => toggleShuffle(!activeItem.shuffle)}  
                          />
                          <span className="switch-label"></span>
                          <span className="switch-handle"></span>
                        </Label>
                        {activeItem.shuffle ? 'Shuffle On' : 'Shuffle Off'}
                       </Col>
                       <Col>
                        <Label className={'switch switch-3d mr-2 switch-' + colorScheme}>
                        <Input 
                          type='checkbox'
                          className='switch-input'
                          value={activeItem.startingLetter === 'f' ? 'off' : 'on'}
                          checked={activeItem.startingLetter === 'f'}
                          disabled={activeItem.shuffle}
                          onChange={() => setStartingLetter(activeItem.startingLetter === 'a' ? 'f' : 'a')}
                        />
                        <span className='switch-label'></span>
                        <span className='switch-handle'></span>
                        </Label>
                        {startingLetter === 'a' ? 'ABCDE' : startingLetter === 'f' ? 'FGHJK' : ''}
                      </Col>
                      <Col xs='12' lg='12'>
                        <ItemInfo 
                          handleInfoChange={handleInfoChange}
                          itemName={itemName}
                          itemCode={itemCode}
                        />
                      </Col>
                      <Col xs='12' lg='12'>
                        <SelectItemType 
                          active={activeItemId ? true : false}
                          activeItemType={activeItemId ? activeItem.itemType : ''}
                          handleChangeItemType={handleChangeItemType}
                        />
                      </Col>
                    </Row>                  
                  </CardBody>
                </Card>
              </Col>
                {nodes &&
                  <NodeTagger 
                    nodes={nodes}
                    nodeTags={activeItem.nodeTags}
                    addNodeTag={addNodeTag}
                    deleteNodeTag={deleteNodeTag}
                    active={activeItemId ? true : false}
                  />  
                }
              <Col xs='12' lg='12'>
                {display.passage && 
                  <PassageCard 
                    activeEditor={activeEditor}
                    activeItemId={activeItemId}
                    passage={passage}
                    openEditor={openEditor}
                    closeEditor={closeEditor}
                    passageId={passageId}
                    editorId={{type: 'passage'}}
                    quillText={quillText}
                    handleQuillChange={handleQuillChange}
                    query={query}
                  />
                }
                {display.question &&
                  <NewContentCard
                    activeItemId={activeItemId}
                    contentType={'question'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.question}
                  />
                }
                {display.content && 
                  <NewContentCard
                    activeItemId={activeItemId}
                    contentType={'content'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.content}
                  />
                }
                {display.imageLink &&
                  <TextInput 
                    contentType={'imageLink'}
                    activeItemId={activeItemId}
                    content={activeItem.imageLink || ''}
                  />
                }
                {display.imageDescription &&
                  <NewContentCard 
                    activeItemId={activeItemId}
                    contentType={'imageDescription'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.imageDescription || ''}
                  />
                }
                {display.teacherGuidance &&
                  <NewContentCard
                    activeItemId={activeItemId}
                    contentType={'teacherGuidance'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.teacherGuidance || ''}
                  />
                }
                {display.instructions &&
                  <NewContentCard 
                    activeItemId={activeItemId}
                    contentType={'instructions'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.instructions || ''}
                  />
                }
                {display.audioLink &&
                  <TextInput 
                    contentType={'audioLink'}
                    activeItemId={activeItemId}
                    content={activeItem.audioLink || ''}
                  />
                }
                {display.audioTranscript &&
                  <NewContentCard 
                    activeItemId={activeItemId}
                    contentType={'audioTranscript'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.audioTranscript || ''}
                  />
                }
                {display.videoLink &&
                  <TextInput 
                    contentType={'videoLink'}
                    activeItemId={activeItemId}
                    content={activeItem.videoLink || ''}
                  />
                }
                {display.videoFeedback &&
                  <TextInput
                    contentType='videoFeedback'
                    activeItemId={activeItemId}
                    content={activeItem.videoFeedback || ''}
                  />
                }
                {display.videoFeedbackThumbnail &&
                  <TextInput
                    contentType='videoFeedbackThumbnail'
                    activeItemId={activeItemId}
                    content={activeItem.videoFeedbackThumbnail || ''}
                  />
                }
                {display.videoTranscript &&
                  <NewContentCard 
                    activeItemId={activeItemId}
                    contentType={'videoTranscript'}
                    loading={loading}
                    activeItem={activeItem}
                    query={query}
                    content={activeItem.videoTranscript || ''}
                  />
                }

              </Col>
              {display.answers && this.state.activeItem && activeItem && activeItem.answers &&
                <AnswerCards 
                  colorScheme={colorScheme}
                  activeEdit={activeItem.activeEdit}
                  answers={activeItem.answers}
                  toggleActiveEditor={this.props.handleChangeActiveEditor}
                  handleDeleteAnswerChoice={this.props.handleDeleteAnswerChoice}
                  handleClickThumb={this.props.handleClickThumb}
                  shuffle={this.props.activeItem.shuffle}
                  startingLetter={this.props.activeItem.startingLetter}
                  handleQuillChange={this.props.handleQuillChange}
                  quillText={this.props.quillText}
                  activeItem={this.state.activeItem}
                  quillActiveItem={this.props.activeItem}
                  copyFeedback={copyFeedback}
                  handleClickSave={handleClickSave}
                  saving={activeItem.isSaving}
                />
              }
              <Col>
                {display.answers && 
                  <Button color='secondary' onClick={this.props.handleAddAnswerChoice}>
                    + Add Choice
                  </Button>
                }
                {' '}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ManageContent




// WEBPACK FOOTER //
// ./src/components/Content/ManageContent.js